module.exports = __webpack_public_path__ + "static/img/13.9f6178d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/13.png
// module id = QGxP
// module chunks = 0